import * as React from 'react';
import { DefaultButton, IDropdownOption, MessageBar, MessageBarType, PrimaryButton } from '@fluentui/react';

import { useEffect, useState } from 'react';
import { IChoiceField, IField, IRuoloAoo, IUser } from '../../../shared/interfaces';
import DynamicForm from '../../DynamicForm/DynamicForm';
import { useBoolean } from '@fluentui/react-hooks';
import AppUtilities from '../../../shared/Utilities/appUtilities';
import CircleLoader from '../../Loader/CircleLoader/CircleLoader';
import usersService from '../../../services/users.service';
import { RootState } from '../../../store';
import { connect, ConnectedProps } from 'react-redux';
import { AddEditUserAoo_Mode, RoleContext } from '../../../shared/enums';
import { RouteComponentProps, withRouter } from 'react-router-dom';



const mapState = (state: RootState) => ({
    allRoles: state.sessionReducer.allRoles,
    userActiveAoo: state.sessionReducer.userActiveAoo,
    currentUser: state.sessionReducer.currentUser
})

const mapDispatch = {

}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface EditRuoloAooProps {
    loading?: boolean
    extraCssClass?: string
    selectedUser: IUser
    onSubmit: (userItem: IUser, addEditUserMode: AddEditUserAoo_Mode) => void
    onDismiss: () => void

}

type Props = EditRuoloAooProps & RouteComponentProps & PropsFromRedux

const EditRuoloAoo: React.FunctionComponent<Props> = (props) => {
    let loading = props.loading !== undefined ? props.loading : false;

    const [messageBarIsVisible, { setTrue: showMessageBar, setFalse: dismissMessageBar }] = useBoolean(false);
    const [messageBarType, setMessageBarType] = useState<MessageBarType>();
    const [messageBarText, setMessageBarText] = useState<string>('');
    const [fields, setFields] = useState<IField[]>([]);
    const [rolesOptions, setRolesOptions] = useState<IDropdownOption[]>([]);


    useEffect(() => {

        resetFields();
        dismissMessageBar();

    }, []);

    useEffect(() => {
        let _rolesOptions = props.allRoles ? props.allRoles.reduce((a: any[], o) => (o.context === RoleContext.Aoo && a.push({ text: o.nome, key: o.id }), a), []) : [];
        setRolesOptions(_rolesOptions);
    }, [props.allRoles]);

    useEffect(() => {
        if (rolesOptions.length > 0) {
            resetFields();
        }
    }, [rolesOptions]);

    const resetFields = () => {

        let ruoloValue;

        let aooId = Number(props.match.params["aooId"]);

        let personaSelezionata = { ...props.selectedUser };

        // Per il ruolo (Admin o Supervisore)
        let admin = usersService.userIsAdmin(personaSelezionata!, aooId);
        if (admin) {
            let adminRole = props.allRoles?.find(el => el.nome === "Admin");
            ruoloValue = adminRole!.id;
        }
        else {
            let supervisore = usersService.userIsSupervisore(personaSelezionata!, aooId);
            if (supervisore) {
                let supervisorRole = props.allRoles?.find(el => el.nome === "Supervisore");

                ruoloValue = supervisorRole!.id;
            }
        }



        //ricreo i fields a partire da initialFields e aggiungo le options per il field ruolo e per il default Aoo
        let newFields: IField[] = [
            {
                displayName: "Ruolo nell'AOO corrente",
                internalName: "ruolo",
                sharepointType: "Choice",
                controlType: "dropdown",
                required: false,
                readonly: false,
                disabled: false,
                system: false,
                internalValue: ruoloValue,
                valid: false,
                touched: false,
                multi: false,
                options: rolesOptions

            } as IChoiceField];

        if (props.currentUser?.isSuperAdmin) {
            newFields.push(
                {
                    displayName: "SuperAdmin",
                    internalName: "isSuperAdmin",
                    sharepointType: "Yes/No",
                    controlType: "boolean",
                    required: false,
                    readonly: false,
                    disabled: false,
                    system: false,
                    internalValue: personaSelezionata.isSuperAdmin,
                    valid: false,
                    touched: false
                } as IField);
        }
        setFields(newFields);
    }

    // Click su salva del panel laterale
    const editRuoloAooSubmit = () => {

        if (checkRuoloAooFormValidity()) {
            let personaSelezionata = { ...props.selectedUser };

            let ruoloId = fields.find(el => el.internalName === 'ruolo')?.internalValue;
            let isSuperAdmin = fields.find(el => el.internalName === 'isSuperAdmin')?.internalValue;

            let aooId = props.match.params["aooId"];


            let ruoliAooContext: IRuoloAoo[] = ruoloId > 0 ? [{ ruoloId, userId: personaSelezionata.id, aooId }] : [];

            let newUser: IUser = { ...personaSelezionata, ruoliAooContext, isSuperAdmin };


            props.onSubmit(newUser, AddEditUserAoo_Mode.EditUserAndRole);
            resetFormFields();
        }
    }

    const resetFormFields = () => {

        let newFields = fields.map(el => {
            return { ...el, internalValue: null, touched: false, valid: true };
        });
        setFields(newFields);
    }

    const checkRuoloAooFormValidity = (): boolean => {

        let isValid = true;

        const updatedFields = fields.map((item, index) => {
            let fieldValidity = AppUtilities.checkFieldValidity(item);
            if (!fieldValidity)
                isValid = false;

            return {
                ...item,
                touched: true,
                valid: fieldValidity
            }
        });
        setFields(updatedFields);
        if (isValid) {
            dismissMessageBar();
        }
        else {
            setMessageBarText('Compilare correttamente i campi');
            setMessageBarType(MessageBarType.error);
            showMessageBar();
        }

        return isValid;
    }


    const inputChangedHandler = (newField: IField) => {

        const updatedFields = [...fields];
        let itemIndex = updatedFields.findIndex(el => el.internalName === newField.internalName);

        dismissMessageBar();

        updatedFields[itemIndex] = { ...newField };

        if (newField.internalName === 'utente' && newField.internalValue) {
            // Quando un utente è selezionato, viene popolato automaticamente il campo email con l'email di dafult
            let userId = newField.internalValue[0]?.key;
            let emailFieldIndex = updatedFields.findIndex(el => el.internalName === 'email');
            let emailField = { ...updatedFields[emailFieldIndex] };
            emailField.internalValue = userId;

            updatedFields[emailFieldIndex] = { ...emailField };
        }

        setFields(updatedFields);
    }

    const onRenderLateralPanelFooterContent = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Salva"
                    onClick={editRuoloAooSubmit}
                />
                <DefaultButton
                    onClick={props.onDismiss}
                    text="Annulla"
                />
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>

            {messageBarIsVisible &&
                <MessageBar
                    messageBarType={messageBarType}
                    isMultiline={false}
                    onDismiss={dismissMessageBar}
                    dismissButtonAriaLabel="Close">{messageBarText}</MessageBar>
            }

            <CircleLoader loaderClass='loader-large' loading={loading} />




            <div className={"flex flex-column position-relative overflow-hidden"}>

                <div className={`position-relative my-scroll-div`}>

                    <DynamicForm
                        fields={fields}
                        onInputChangedHandler={(newField) => { inputChangedHandler(newField) }}
                    />
                    {onRenderLateralPanelFooterContent()}

                </div>
            </div>

        </React.Fragment>

    );
}

export default connector(withRouter(EditRuoloAoo));
